import React from 'react';
import { MDBCardBody, MDBCard, MDBContainer, MDBTable, MDBTableBody, MDBTableHead, MDBDataTable, MDBRow, MDBCol, MDBInput, MDBBtn, MDBSelect, MDBIcon } from 'mdbreact';
import DataLayer from '../Utilities/DataLayer';
import Header from './ComponentFragments/Header';
import Formatter from '../Utilities/Formatter';
import DashboardLineGraph from './ComponentFragments/DashboardLineGraph';

export default class Rankings extends React.Component {

    constructor(props) {
        super(props);
        this.props.loaderOn();
        this.state = {
            teamData: [],
            rank: '',
            direction: '',
            places: '',
        }
        this.formatter = new Formatter();

    }

    //async loadSegmentsForYear(year) {
    //    this.props.loaderOn();
    //    var dl = new DataLayer();
    //    let result = await dl.Get('/common/getsegmentsforyear?yearId=' + year, 200);
    //    let qualDataResult = await dl.Get('/demonstrator/getGetUpQualificationData?segmentId=' + this.state.currSegment, 200);
    //    let segData = [];
    //    result.data.forEach((segment) => segData.push(
    //        { checked: segment.periodId == this.state.currSegment ? true : false, value: segment.periodId, text: segment.description }
    //    ));
    //    let earn1 = 0;
    //    let earn2 = 0;
    //    let earn3 = 0;
    //    qualDataResult.data.forEach((qual) => {
    //        switch (qual.mdResultCode) {
    //            case "881":
    //                earn1 = qual.amount;
    //                break;
    //            case "882":
    //                earn2 = qual.amount;
    //                break;
    //            case "883":
    //                earn3 = qual.amount;
    //                break;
    //        }
    //    });

    //    this.setState({
    //        segmentData: segData,
    //        selectedSegment: segData[0].value,
    //        earnM1: earn1,
    //        earnM2: earn2,
    //        earnM3: earn3

    //    })

    //    this.props.loaderOff();
    //}

    //handleUnitSelectChange(selected) {
    //    this.setState({
    //        selectedUnit: selected[0]
    //    });
    //}

    //handleYearSelectChange(selected) {
    //    this.setState({
    //        selectedYear: selected[0]
    //    });
    //    this.loadSegmentsForYear(selected[0])
    //}

    //handleSegmentSelectChange(selected) {
    //    this.setState({
    //        selectedSegment: selected[0]
    //    });
    //}



    async componentWillMount() {

        this.props.loaderOn();
        var dl = new DataLayer();
        let rankingData = await dl.Get('/teamleader/getsalesranking', 200);
        //await dl.Get('/teamleader/GetTeamPerformance?fromWeek=' + this.state.selectedFromWeek + '&toWeek=' + this.state.selectedToWeek, 200).then((response) => {
        let rankings = [];
        let rec;

        rankingData.data[0].rankDetail.map((dem) => {
            rec = {
                position: dem.position,
                movement: dem.places == '0' ? "No movement from previous segment" : dem.direction == 'Up' ? [<MDBIcon className="green-text" icon="angle-double-up" />, ' ' + dem.direction + ' ' + dem.places + ' Places From Previous Segment'] : [<MDBIcon className="red-text" icon="angle-double-down" />, ' ' + dem.direction + ' ' + dem.places + ' Places From Previous Segment'],
                code: dem.code,
                name: dem.name,
                //period: dem.period,
                firstNames: dem.firstNames,
                surname: dem.surname,
                dsName: dem.dsName,

            }
            rankings.push(rec);
        });
        let tableData = {
            columns: [{
                label: 'Position',
                field: 'position',
                sort: 'asc'
            },
                {
                    label: 'Movement',
                    field: 'movement',
                    sort: 'asc'
                },
            {
                label: 'Team Code',
                field: 'code',
                sort: 'asc'
            },
            {
                label: 'Team Name',
                field: 'name',
                sort: 'asc'
            },
            {
                label: 'First Names',
                field: 'firstNames',
                sort: 'asc'
            },
            {
                label: 'Surname',
                field: 'surname',
                sort: 'asc'
            },
            {
                label: 'Ship',
                field: 'dsName',
                sort: 'asc'
            }],
            rows: rankings
        }
        this.setState({
            teamData: tableData,
            rank: rankingData.data[0].rank,
            direction: rankingData.data[0].direction,
            places: rankingData.data[0].places,
        });
        this.props.loaderOff();
    }

    async getGetUpData() {



    }

    render() {
        let TMAUser = JSON.parse(localStorage.getItem("TMAUser"));
        let statusType = TMAUser.data.statusCode1;
        let statusType2 = TMAUser.data.statusCode2;
        let headerText = 'Your Africa Ranking (Team Sales - ' + statusType + statusType2 + ')'
        let subHeaderText = '(Based on total team sales for current segment.)'
        if (statusType == 'M') {
            headerText = 'Your Africa Ranking (Unit Sales - ' + statusType + statusType2 + ')'
            subHeaderText = '(Based on total unit sales for current segment.)'
        }
        return (
            <div>
                <Header headerText={headerText}
                    subHeaderText={subHeaderText}
                    hideSearch='true'
                />
                <div style={{ paddingTop: "30px" }}>
                    <MDBRow>
                        <MDBCol className="mb-r" >
                            <MDBCard className="cascading-admin-card">
                                <div className="admin-up">
                                    <MDBIcon icon='chart-line' style={{ backgroundColor: 'green' }} />
                                    <div className="data">
                                        <h5><strong>You Are Currently In Position&nbsp;{this.state.rank}</strong></h5>
                                        <h5><strong>{this.state.direction}&nbsp;{this.state.places}&nbsp;Places From Previous Segment</strong></h5>
                                    </div>
                                </div>
                                <MDBCardBody>
                                    <MDBRow>
                                        <MDBCol className="text-center">
                                            <div className="text-center">
                                            <MDBDataTable
                                                responsive
                                                striped
                                                bordered
                                                hover
                                                data={this.state.teamData}
                                                paging={false}
                                                autoWidth
                                                searching={false}
                                                />
                                                </div>
                                        </MDBCol>
                                    </MDBRow>
                                </MDBCardBody>
                            </MDBCard>
                        </MDBCol>
                    </MDBRow>
                </div>
            </div>
        );
    }


}
